import { ChevronDownIcon } from "lucide-react";
import { Button } from "@component/button";
import { cn } from "@util/tailwind";

interface DeviceSelectorButtonProps {
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    className?: string;
}

export default function DeviceSelectorButton({
    icon,
    label,
    onClick,
    className,
}: DeviceSelectorButtonProps) {
    return (
        <Button
            variant="ghost"
            className={cn(
                "flex items-center justify-between gap-2 px-3 py-2 h-auto text-sm font-normal bg-white dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800 w-full",
                className
            )}
            onClick={onClick}
        >
            <div className="flex items-center gap-2 min-w-0 flex-1">
                {icon}
                <span className="truncate">{label}</span>
            </div>
            <ChevronDownIcon className="h-4 w-4 flex-shrink-0 text-gray-500" />
        </Button>
    );
}
